import React from 'react';
import Lodash from 'lodash';
import store from '../../store/store';
import { updateUser } from '../../store/actions/actions';
import { withRouter } from 'react-router';

import Card from '../../models/card';

import './game.scss';

import Form from '../form/form';
import Modal from '../modal/modal';
import Toolbar from '../toolbar/toolbar';
import CardList from '../card-list/card-list';

type Props = {
  match: any;
  history: any;
  location: any;
  cards: Card[];
};

type State = {
  cards: Card[];
  pairs: number;
  guesses: number;
  isOpen: boolean;
};

class Game extends React.Component<Props, State> {
  state: State = {
    cards: this.generateNewPairs(this.props.cards),
    pairs: 0,
    guesses: 0,
    isOpen: false,
  };

  constructor(props: Props) {
    super(props);
    this.restartGame = this.restartGame.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleUsers = this.handleUsers.bind(this);
    this.handleProgress = this.handleProgress.bind(this);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.cards !== this.props.cards) {
      this.setState({ cards: this.generateNewPairs(this.props.cards) });
    }
  }

  generateNewPairs(cards: Card[]): Card[] {
    const selectedCards = Lodash.shuffle(cards).slice(0, 8);
    return Lodash.shuffle(selectedCards.reduce<Card[]>((cards, card) => [...cards, { ...card }, { ...card }], []));
  }

  restartGame() {
    this.setState({ cards: this.generateNewPairs(this.props.cards), guesses: 0, pairs: 0, isOpen: false });
  }

  toggleModal() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleProgress(matchedCards: Card[]) {
    this.setState({ guesses: this.state.guesses + 1, pairs: matchedCards.length / 2 });
    if (this.state.cards.length === matchedCards.length) {
      this.toggleModal();
    }
  }

  handleUsers(name: string) {
    const { guesses } = this.state;
    store.dispatch(updateUser({ name, date: new Date().toLocaleString(), guesses, rating: 0 }));
    this.setState({ isOpen: false });
    this.props.history.push('/stats');
  }

  render() {
    return (
      <section className="game">
        <Toolbar pairs={this.state.pairs} guesses={this.state.guesses} restartGame={this.restartGame} />

        <CardList cards={this.state.cards} handleProgress={this.handleProgress} />

        <Modal title="Save your game" text="Congratulations !" isText={true} isOpen={this.state.isOpen} toggleModal={this.toggleModal}>
          <Form handleUsers={this.handleUsers} />
        </Modal>
      </section>
    );
  }
}

export default withRouter(Game);
